<template>
  <div class="newpage">
    <div class="printTest-box">
      <div id="printTest">
        <div style="display: flex;flex-direction: column;align-items: center;">
          <div>
            <loading class="loading_style" :tip="tip" v-if="!th_printdata.length"></loading>
            <div ref="menuItem" v-else>
              <div :style="item.genre === 'order' ? sliderStyle : sliderStyleCopy" v-for="(item, index) in listCopy"
                :key="index">
                <div v-if="item.genre === 'order'" style="height: 100%;display: flex;flex-direction: column;">
                  <div style="width: 100%;display: flex;justify-content: space-between;">
                    <span class="desc">{{ item.printNum + 1 }}st print</span>
                    <span class="desc">NO.{{ item.No + 1 }}</span>
                  </div>
                  <div class="loading-box" v-if="!item.orderPdf">
                    <div class="desc_failed">{{ $t('other.a496') }}</div>
                  </div>
                  <div class="loading-box" v-if="item.orderPdf && !item.orderPdf.image">
                    <div class="desc_failed">{{ $t('other.a496') }}</div>
                  </div>
                  <div style="width: 100%;overflow: hidden;">
                    <div style="height: 100%;">
                      <!-- <img style="width: 100%;" :src="item.orderPdf && item.orderPdf.image" /> -->
                      <img style="width: 100%;height: 100%;" :src="item.orderPdf && item.orderPdf.image" />
                    </div>
                  </div>
                  <div style="text-align:center;font-size: 12px;">
                    <div v-for="(ccp, index01) in listCopy[index+1].itemsCopy" style="display: inline-block;">
                      <div style="display: inline-block;" v-for="(oop, index03) in ccp">
                        <span>{{ oop.skuName }}<span v-if="!oop.standardPattern&&!oop.pintImage">-NO</span> * {{ oop.rate * oop.purchaseNum }}</span>
                        <span v-if="ccp.length>0&&index03<ccp.length-1||listCopy[index+1].itemsCopy.length>0&&index01<listCopy[index+1].itemsCopy.length-1">，</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 拣货单	 -->
                <div style="box-sizing: border-box;padding: 5px 10px;" v-if="item.genre === 'picklist'">
                  <div style="width: 100%;display: flex;justify-content: space-between;">
                    <div>
                      <div>{{ item.genre }}</div>
                      <div style="font-size: 12px;">buyer：{{ item.buyerName }}</div>
                      <div style="font-size: 12px;">total：{{ item.itemsCopy.length }}</div>
                      <div style="font-size: 12px;">print time：{{ getTiem(item.printTime) }}</div>
                    </div>
                    <span>{{ item.orderId }}</span>
                  </div>
                  <div style="border-bottom: 1px #000000 solid;padding: 5px 0 ;font-size: 12px;">
                    <span style="display: inline-block;width: 30px;">#</span>
                    <span style="display: inline-block;width: 73px;">p_sku</span>
                    <span style="display: inline-block;width: 80px;">w_sku</span>
                    <span style="display: inline-block;width: 80px;">Position</span>
                    <span style="display: inline-block;width: 30px;">Qty</span>
                  </div>
                  <div style="display:flex;font-size: 10px; border-bottom: 1px solid #E0E0E0;padding: 3px 0;"
                    v-for="(ccp, index01) in item.itemsCopy" :key="index01">
                    <span style="display: inline-block;width: 30px;">{{ index01 + 1 }}</span>
                    <div>
                      <div style="display:flex" v-for="(oop, index03) in ccp" :key="index03">
                        <div style="width:52px;word-break:break-all">{{ oop.itemSku }}</div>

                        <div style="width:70px;word-break:break-all;padding:0 10px">{{ oop.skuName }}<span v-if="!oop.standardPattern&&!oop.pintImage">-NO</span></div>

                        <div style="width:70px;word-break:break-all;padding:0 10px">{{ oop.address }}</div>
                        <div style="padding:0 10px">{{ oop.rate * oop.purchaseNum }}</div>

                        <div v-show="!oop.addition">{{ oop.isComponent ? $t('other.a251') : $t('other.a252') }}</div>
                        <div v-show="oop.addition">{{ $t('other.a497') }}</div>
                      </div>
                    </div>
                  </div>
                  <div style="font-size:14px">{{ $t('other.a498') }}:{{ item.messageToSeller ? item.messageToSeller :
                    $t('other.a354') }}</div>
                  <div style="font-size:14px">{{ $t('other.a499') }}:{{ item.note ? item.note : $t('other.a354') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1;">
      <div style="height: 200px;">
        <el-button style="margin: 20px 0 0 30px;" type="primary" v-print="'#printTest'" @click="addPrintNum()">{{
          $t('other.a342') }}</el-button>
        <el-button id="pprint" style="margin: 20px 0 0 30px;" type="primary" @click="getWaterPiuture()">{{
          $t('other.a930') }}</el-button>
        <!-- <button @click="start_print">开始打印</button> v-print="'#printTest'" -->
      </div>
      <div style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
        <div style="font-size: 14px;padding-left: 10px;">{{ $t('other.a346') }}</div>
        <el-select style="margin-left: 15px;" size="mini" v-model="value" :placeholder="$t('other.a50')"
          @change="chosePage()">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div v-show="value == '10'"
        style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
        <div style="font-size: 14px;padding-left: 10px;">{{ $t('other.a347') }}</div>
        <el-input style="width:120px;padding-left:15px" @keyup.native="oop" size="mini" v-model="widthValue"
          :placeholder="$t('other.a319')"></el-input>
        <label style="font-size:14px;padding-left:10px">{{ $t('other.a349') }}</label>
      </div>
      <div v-show="value == '10'"
        style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
        <div style="font-size: 14px;padding-left: 10px;">{{ $t('other.a348') }}</div>
        <el-input style="width:120px;padding-left:15px" @keyup.native="oop1" size="mini" v-model="heightValue"
          :placeholder="$t('other.a319')"></el-input>
        <label style="font-size:14px;padding-left:10px">{{ $t('other.a349') }}</label>
      </div>

      <div>
        <div style="font-size: 14px;padding:0 0 10px 10px;">{{ $t('other.a931') }}:</div>
        <div class="methods">
          <el-radio v-model="radio" label="1">{{ $t('other.a932') }}</el-radio>
          <el-radio v-model="radio" label="2">{{ $t('other.a933') }}</el-radio>
          <el-radio v-model="radio" label="3">{{ $t('other.a933') }}</el-radio>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "../../../../utils/utils";
import printApi from "../../../../api/moudles/print.js";
import api from "../../../../api/api";
import newOrderApi from "../../../../api/moudles/newOrders";
import orderApi from "../../../../api/moudles/order";
import loading from "../../../../components/loading_2.vue";

import { mapState, mapMutations, mapActions } from "vuex";

import pdf from "vue-pdf";

import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

export default {
  data() {
    return {
      userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      th_printdata: [],
      radio: "1",
      barcodeValue: 123,
      orderList: [],
      storeItemList: [],
      tip: this.$t("other.a500"),
      arr: [],

      options: [
        {
          value: 1,
          label: this.$t("other.a493")
        },
        {
          value: 2,
          label: this.$t("other.a494")
        },
        {
          value: 3,
          label: this.$t("other.a350")
        },
        {
          value: 4,
          label: this.$t("other.a351")
        }
      ],
      value: 3,
      sliderStyle: {
        width: "101.6mm",
        height: "152.4mm",
        "background-color": "#fff",
        "margin-top": "10px",
        position: "relative",
        "page-break-after": "always"
      },

      sliderStyleCopy: {
        width: "101.6mm",
        "min-height": "152.4mm",
        "background-color": "#fff",
        "margin-top": "10px",
        position: "relative",
        "page-break-after": "always"
      },
      widthValue: "101.6",
      heightValue: "152.4",
      checked: false,
      options: [
        {
          value: "10",
          label: this.$t("other.a350")
        },
        {
          value: "20",
          label: "A4"
        },
        {
          value: "30",
          label: "A5"
        }
      ],
      value: "10",
      loadingList: [],
      loadedList: [],
      currentPage2: 1,
      pageSize: 10,
      chooseList: null,
      generateOrderId: [],
      pageImages: [],

    };
  },
  components: {
    loading,
    pdf
  },
  computed: {
    ...mapState({
      picklist: state => state.order.picklist,
      seller: state => state.login.userInfo.userId,
      buttonMapList: state => state.print.buttonMapList,
      toPrintOrders: state => state.common.toPrintOrders
    }),

    listCopy() {
      let list = this.th_printdata;
      console.log(this.th_printdata)
      let list2 = list;
      let list3 = [];
      if (this.radio == "1") {
        list3 = list2;
      } else if (this.radio == "2") {
        list3 = list2.filter(p => {
          if (p.genre == "order") {
            return p;
          }
        });
      } else if (this.radio == "3") {
        list3 = list2.filter(p => {
          if (p.genre == "picklist") {
            return p;
          }
        });
      }
      console.log("list3", list3);

      this.chooseList = list3;



      return list3;
    }
  },
  watch: {
    storeItemList() {
      let list = this.orderList;
      let storeItem = this.storeItemList;

      list.forEach(p => {
        p.items.forEach(i => {
          i.storeItem = storeItem[i.itemId + "_" + i.variationId];
        });
      });
      console.log("list", list);
      this.th_printdata = list;
    },
    radio() {
      let ttp = this.radio;
      console.log("ttp", ttp);
    }
  },
  created() {
    // this.src=pdf.createLoadingTask(this.src)
    this.getOrdersByOrderId();
    pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
  },

  methods: {
    ...mapActions("order", [
      "getUnprocessOrder", //获取所有商店待处理订单
      "auditOrder",
      "getPrintOrder", //打印订单
      "getOrdersBytrickNo"
    ]),
    ...mapActions("print", ["addPrintNum"]),
    ...mapMutations("print", [
      "SET_ITEMS",
      "SET_HAS_PRINTED",
      "SET_TTP",
      "SET_HAS_PRINTED_READY",
      "INIT_DATA",
      "FAST_PRINT",
      "UPDATA_PAGE",
      "SENT_PPT"
    ]),
    async loadPdf(url, index) {
      const loadingTask = pdfjsLib.getDocument(url)
      const pdf = await loadingTask.promise
      let imgUrl = null;
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i)
        const viewport = page.getViewport({ scale: 5 })

        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        var CSS_UNITS = 96.0 / 72.0
        console.log(CSS_UNITS)
        canvas.height = viewport.height
        canvas.width = viewport.width
        // canvas.height = Math.floor(viewport.height * CSS_UNITS);
        // canvas.width = Math.floor(viewport.width * CSS_UNITS) ;

        // 计算物理像素比


        await page.render({
          // transform: [CSS_UNITS, 0, 0, CSS_UNITS, 0, 0],
          canvasContext: context,
          viewport: viewport,
          intent: 'quality'
        }).promise

        // this.pageImages.push(canvas.toDataURL('image/png'))
        // console.log(this.pageImages)
        imgUrl = canvas.toDataURL('image/jpeg');
        this.downloadBase64Img(this.changeDpiDataUrl(imgUrl,
          300), index)
      }
    },
    downloadBase64Img(base64URL, index) {
      // 创建 Blob 对象，并获取 base64 数据的 MIME 类型
      const mimeType = base64URL.match(/:(.*?);/)[1];
      // 将 base64 数据转换为字节数组
      const byteCharacters = atob(base64URL.split(',')[1]);
      const byteNumbers = new Array(byteCharacters.length);
      // 将字节数组填充到 Uint8Array 中
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      // 创建 Blob 对象
      const blob = new Blob([byteArray], {
        type: mimeType
      });
      // 将 Blob 对象的 URL 赋值给 a 标签的 href 属性
      // a.href = URL.createObjectURL(blob);
      this.th_printdata[index].orderPdf.image = URL.createObjectURL(blob);
    },

    changeDpiDataUrl(base64Image, dpi) {
      const PNG = 'image/png';
      const JPEG = 'image/jpeg';
      const dataSplitted = base64Image.split(',');
      const format = dataSplitted[0];
      const body = dataSplitted[1];
      let type;
      let headerLength;
      let overwritepHYs = false;
      if (format.indexOf(PNG) !== -1) {
        type = PNG;
        const b64Index = detectPhysChunkFromDataUrl(body);
        // 28 bytes in dataUrl are 21bytes, length of phys chunk with everything inside.
        if (b64Index >= 0) {
          headerLength = Math.ceil((b64Index + 28) / 3) * 4;
          overwritepHYs = true;
        } else {
          headerLength = 33 / 3 * 4;
        }
      }
      if (format.indexOf(JPEG) !== -1) {
        type = JPEG;
        headerLength = 18 / 3 * 4;
      }
      // 33 bytes are ok for pngs and jpegs
      // to contain the information.
      const stringHeader = body.substring(0, headerLength);
      const restOfData = body.substring(headerLength);
      const headerBytes = atob(stringHeader);
      const dataArray = new Uint8Array(headerBytes.length);
      for (let i = 0; i < dataArray.length; i++) {
        dataArray[i] = headerBytes.charCodeAt(i);
      }
      const finalArray = this.changeDpiOnArray(dataArray, dpi, type, overwritepHYs);
      const base64Header = btoa(String.fromCharCode(...finalArray));

      return [format, ',', base64Header, restOfData].join('');
    },

    changeDpiOnArray(dataArray, dpi, format, overwritepHYs) {
      // console.log(3)
      const PNG = 'image/png';
      const JPEG = 'image/jpeg';

      if (format === JPEG) {
        dataArray[13] = 1; // 1 pixel per inch or 2 pixel per cm
        dataArray[14] = dpi >> 8; // dpiX high byte
        dataArray[15] = dpi & 0xff; // dpiX low byte
        dataArray[16] = dpi >> 8; // dpiY high byte
        dataArray[17] = dpi & 0xff; // dpiY low byte
        return dataArray;
      }
      if (format === PNG) {
        const physChunk = new Uint8Array(13);
        // chunk header pHYs
        // 9 bytes of data
        // 4 bytes of crc
        // this multiplication is because the standard is dpi per meter.

        const _P = 'p'.charCodeAt(0);
        const _H = 'H'.charCodeAt(0);
        const _Y = 'Y'.charCodeAt(0);
        const _S = 's'.charCodeAt(0);
        dpi *= 39.3701;
        physChunk[0] = _P;
        physChunk[1] = _H;
        physChunk[2] = _Y;
        physChunk[3] = _S;
        physChunk[4] = dpi >>> 24; // dpiX highest byte
        physChunk[5] = dpi >>> 16; // dpiX veryhigh byte
        physChunk[6] = dpi >>> 8; // dpiX high byte
        physChunk[7] = dpi & 0xff; // dpiX low byte
        physChunk[8] = physChunk[4]; // dpiY highest byte
        physChunk[9] = physChunk[5]; // dpiY veryhigh byte
        physChunk[10] = physChunk[6]; // dpiY high byte
        physChunk[11] = physChunk[7]; // dpiY low byte
        physChunk[12] = 1; // dot per meter....

        const crc = calcCrc(physChunk);

        const crcChunk = new Uint8Array(4);
        crcChunk[0] = crc >>> 24;
        crcChunk[1] = crc >>> 16;
        crcChunk[2] = crc >>> 8;
        crcChunk[3] = crc & 0xff;

        if (overwritepHYs) {
          const startingIndex = searchStartOfPhys(dataArray);
          dataArray.set(physChunk, startingIndex);
          dataArray.set(crcChunk, startingIndex + 13);
          return dataArray;
        } else {
          // i need to give back an array of data that is divisible by 3 so that
          // dataurl encoding gives me integers, for luck this chunk is 17 + 4 = 21
          // if it was we could add a text chunk contaning some info, untill desired
          // length is met.

          // chunk structur 4 bytes for length is 9
          const chunkLength = new Uint8Array(4);
          chunkLength[0] = 0;
          chunkLength[1] = 0;
          chunkLength[2] = 0;
          chunkLength[3] = 9;

          const finalHeader = new Uint8Array(54);
          finalHeader.set(dataArray, 0);
          finalHeader.set(chunkLength, 33);
          finalHeader.set(physChunk, 37);
          finalHeader.set(crcChunk, 50);
          return finalHeader;
        }
      }
    },
    getWaterPiuture() {
      let that = this;
      var canvas = document.createElement("canvas");
      canvas.width = 800;
      canvas.height = 800;
      let ctx = canvas.getContext("2d");

      let homeImg = this.listCopy[0].orderPdf.image;
      let picImg = new Image();
      picImg.setAttribute("crossOrigin", "anonymous");
      picImg.src = homeImg;

      picImg.onload = function () {
        ctx.drawImage(picImg, 0, 0, "100mm", "150mm");
        let base64 = canvas.toDataURL("image/png");
        console.log("base64", base64);

        // let image=new Image()
        // image.src=waterImg
        // image.setAttribute('crossOrigin', 'anonymous');
        // image.onload = function() {
        // 	ctx.drawImage(image,0,0,800,800);
        // 	let base64=canvas.toDataURL('image/png')

        // }
      };
    },
    getOrdersByOrderId() {
      let list = JSON.parse(localStorage.getItem("unprocessedOrderIds"));

      newOrderApi.getOrderPDF(list).then(res => {
        if (res.code === 200) {
          console.log("获取到订单数据", res.data);
          res.data.forEach((p, index) => {
            p.No = index;
          });
          this.th_printdata = res.data;
          // for (let i = 0; i < this.th_printdata.length; i++) {
          //   if (this.th_printdata[i].orderPdf.image && this.isImage(this.th_printdata[i].orderPdf.image)) {
          //   } else {
          //     console.log(i)
          //     let newStr = this.th_printdata[i].orderPdf.pdf.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddapi");
          //     this.loadPdf(newStr, i)
          //   }
          // }
          this.init();
          console.log("originData", res.data);
        }
      });
    },
    isImage(filename) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp']; // 可能的图片文件后缀名

      const fileExtension = filename.substring(filename.lastIndexOf('.')).toLowerCase(); // 获取文件后缀名，并转为小写

      return imageExtensions.includes(fileExtension); // 判断文件后缀名是否在图片后缀名列表中
    },
    init() {
      this.arr = JSON.parse(JSON.stringify(this.th_printdata));
      console.log("arr", this.arr);

      this.arr.forEach(p => {
        let list3 = [];
        p.itemsCopy = [];
        if (p.items.length > 0) {
          p.items.forEach(k => {
            if (
              !k.storeItem ||
              !k.storeItem.children ||
              k.storeItem.component
            ) {
              //判断items里的每个item是不是套餐，不是才push

              k.cusCode = k.storeItem ? k.storeItem.cusCode : this.$t('other.a354');
              k.skuName = k.storeItem ? k.storeItem.skuName : this.$t('other.a354');
              k.address = k.storeItem ? k.storeItem.address : this.$t('other.a354');
              k.itemSku = k.storeItem ? k.storeItem.itemSku : k.itemSku;
              k.purchaseNum = k.variationQuantityPurchased;
              k.rate = 1;
              console.log(k,'-------k')
              p.itemsCopy.push([k]);
              k.isComponent = true;
            }

            if (k.storeItem && k.storeItem.additions !== null) {
              if (k.storeItem.additions.length > 0) {
                let arr2 = [];
                k.storeItem.additions.forEach(p => {
                  p.purchaseNum = k.variationQuantityPurchased;
                  console.log(p,'======p')
                  arr2.push(p);
                });

                list3.push(arr2);
              }
            }

            if (k.storeItem && k.storeItem !== null && k.storeItem.children) {
              if (k.storeItem.children.length > 0 && !k.storeItem.component) {
                k.isComponent = false;
                let list2 = [];
                k.storeItem.children.forEach(i => {
                  i.purchaseNum = k.variationQuantityPurchased;
                  i.pintImage = k.pintImage;
                  i.standardPattern = k.standardPattern;
                  list2.push(i);
                });
                list3.push(list2);
              }
            }
          });
        }
        if (list3.length) {
          list3.forEach(i => {
            console.log(i,'======i')
            p.itemsCopy.push(i);
          });
        }
      });
      console.log("arr2", this.arr);
      this.th_printdata.forEach(p => {
        p.genre = "order";
      });

      this.arr.forEach(p => {
        p.genre = "picklist";
      });

      this.th_printdata = [...this.th_printdata, ...this.arr];
      this.th_printdata.sort((a, b) => {
        return a.No - b.No;
      });

      for (let i = 0; i < this.th_printdata.length; i++) {
        console.log(this.th_printdata[i].orderPdf)
        if (this.th_printdata[i].orderPdf) {
          if (this.th_printdata[i].orderPdf.image && (this.isImage(this.th_printdata[i].orderPdf.image) || this.th_printdata[i].orderPdf.image.indexOf('data:image/png;base64') != -1) || (this.th_printdata[i].orderPdf.image.indexOf('blob:') != -1)) {
            // console.log(i)
          } else {
            console.log(i)
            // let newStr = this.th_printdata[i].orderPdf.pdf.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi");
            // console.log(newStr)
            this.loadPdf(this.th_printdata[i].orderPdf.pdf, i)
          }
        }
      }
      console.log("852", this.th_printdata);
    },

    addPrintNum() {
      console.log(112233)
      let list = JSON.parse(localStorage.getItem("unprocessedOrderIds"));
      newOrderApi.addPrintNum(list).then(res => {
        if (res.code === 200) {
          console.log("增加了打印次数！");
        } else {
          console.log("增加了打印次数！", res.msg);
        }
      });

      let obj = {
        userId: this.userId,
        orderIds: list.join(),
        createTime: null,
        printType: "3"
      };

      this.insterPrintRecode(obj);
    },

    insterPrintRecode(obj) {
      newOrderApi.insertPrintHistory(obj).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    start_print() {
      this.$print(this.$refs.dfbfjj); //$refs的值要和html里的ref一致
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = parseInt(`${val}`);
    },
    handleCurrentChange(val) {
      this.currentPage2 = parseInt(`${val}`);
      console.log(this.chooseList);
      this.getPirntPdf();
    },
    //开启分批打印时，触发面单再次请求
    getPirntPdf() {
      setTimeout(() => {
        console.log(this.chooseList);
        let arr = this.chooseList.map(p => {
          return p.logisticInfo && p.trackingNo === ""
            ? JSON.parse(p.logisticInfo.info_needed.methods)
            : null;
        });
        arr = utils.unique(arr);
        arr[0] === null ? arr.splice(0, 1) : arr[0];

        this.generateOrderId = arr.map(p => {
          if (p !== null) {
            return p.orderId;
          }
        });

        console.log(arr);
        console.log(this.generateOrderId);
        if (this.generateOrderId.length) {
          console.log(8888);
          printApi.startReadyOrders(arr).then(res => {
            if (res.code === 200) {
              console.log("发送订单请求", res.data);
              this.getNewOrderList(this.generateOrderId);
            }
          });
        }
      }, 1000);
    },

    //获取最新的面单
    getNewOrderList(arr) {
      printApi.getNewOrders(arr).then(res => {
        if (res.code === 200) {
          console.log("获取到最新的订单", res.data);
          let newData = res.data;
          newData.forEach(p => {
            this.th_printdata.forEach(i => {
              if (
                i.orderId == p.orderId &&
                p.image !== null &&
                p.ready == true
              ) {
                i.image = p.image;
              }
            });
            this.generateOrderId.forEach((k, index) => {
              if (k === p.orderId && p.ready == true && p.image !== null) {
                this.generateOrderId.splice(index, 1);
              }
            });
          });

          if (this.generateOrderId.length > 0) {
            this.getNewOrderList(this.generateOrderId);
          }
        }
      });
    },

    chosePage() {
      console.log(this.value);
      if (this.value == "20") {
        this.sliderStyle.width = "210mm";
        this.sliderStyle.height = "297mm";
      } else if (this.value == "30") {
        this.sliderStyle.width = "148mm";
        this.sliderStyle.height = "210mm";
      } else if (this.value == "10") {
        this.sliderStyle.width = "101.6mm";
        this.sliderStyle.height = "152.4mm";
        this.widthValue = "101.6";
        this.heightValue = "152.4";
      }
    },

    refreshOrder(item) {
      console.log(item);
      printApi
        .startReadyOrders({
          userId: this.userId,
          type: 0,
          orderId: item.orderId
        })
        .then(res => {
          if (res.code === 200) {
            console.log("重新加载面单", res.msg);
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    oop1() {
      console.log(this.heightValue)
      this.sliderStyle.height = (this.heightValue + "mm");
    },
    oop() {
      console.log(this.widthValue);
      this.sliderStyle.width = this.widthValue + "mm";
    },
    //深拷贝数组
    copy(obj) {
      var newobj = [];
      if (typeof obj !== "object") {
        return;
      }
      for (var i in obj) {
        newobj[i] = typeof obj[i] === "object" ? this.copy(obj[i]) : obj[i];
      }
      return newobj;
    },
    //从storage上拿下将要打印的item

    ttp() {
      var headstr = "<html><head><title></title></head><body>";
      var footstr = "</body>";
      var newstr = this.$refs.menuItem.innerHTML;
      const oldstr = document.body.innerHTML;
      document.body.innerHTML = headstr + newstr + footstr;
      setTimeout(() => {
        document.body.innerHTML = oldstr;
      }, 1000);
      window.print();
      return false;
    },

    getTiem(time) {
      if (typeof time == Array) {
        return "pending update";
      } else {
        return utils.renderTime(time);
      }
    }
  }
};
</script>

<style>
.newpage {
  width: 100%;
  background: #fff;
  z-index: 99999;
  display: flex;
  position: absolute;
  /* display: flex;
		flex-direction: column;
		justify-content: center; */
}

.newpage .el-radio {
  margin-bottom: 8px;
}

.newpage .methods {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 15px;
}

.newpage .item_order_desc {
  padding-right: 3px;
}

@page {
  margin: 0mm 0mm 0mm 0mm;
}

@page: first {
  margin-top: -5mm;
}

.pic-box {
  width: 100%;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}

.newpage .pick-list-wrpper {
  width: 100%;

  font-size: 12px;
  position: relative;
}

.orderpage-btn {
  width: 800px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}

.newpage .print-area {
  margin-bottom: 200px;
}

.desc-info {
  width: 798px;

  border: 2px #000000 solid;
}

.newpage .loading-box {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.newpage .orderpage-poo-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 5px;
  border-bottom: 2px #000000 dashed;
}

.newpage .desc_failed {
  padding: 8px 0;
  text-align: center;
  color: rgb(152 148 148);
}

.newpage .orderpage-poo {
  min-width: 265px;
  height: 40px;
  border: 2px solid #000000;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
  margin: 5px 10px;
}

.newpage .receipt-item {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 5px 10px;
}

.newpage .receipt-item .area {
  display: inline-block;
  width: 50%;
  font-size: 18px;
}

.newpage .desc-info-left-text {
  font-size: 18px;
  font-weight: bold;
  padding-right: 30px;
}

.newpage .desc-info-footer {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 5px 10px;
}

.newpage .tto {
  display: inline-block;
  width: 200px;
  text-align: center;
  box-sizing: border-box;
  padding: 5px;
}

.newpage .tto01 {
  display: inline-block;
  width: 100px;
}

.newpage .cco {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  border-bottom: 1px #000000 solid;
  box-sizing: border-box;
  padding: 0 10px;
}

.newpage .city-tap {
  display: inline-block;
  padding: 5px;
  border: 2px solid #000000;
  margin: 5px 0;
  padding: 5px 15px;
  font-size: 18px;
}

.newpage .city-tap01 {
  display: inline-block;
  padding: 5px;
  border: 2px solid #000000;
  margin: 5px 5px;
  font-size: 18px;
  padding: 5px 15px;
}

.newpage .desc {
  /* position: absolute;
		top: 40%;
		left: 25%;
		bottom: 0;
		right: 0;
		margin: auto; */
  font-size: 10px;
  font-weight: bold;
  color: red;
  opacity: 0.3;
}

.newpage .oook {
  margin-bottom: 20px;
}

/* 	.pp-wrapper{
		position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto;
	}	 */

.newpage .printTest-box {
  width: 80%;
  overflow-y: auto;
  height: 100vh;
  background-color: #000;
  position: relative;
}

.newpage .page-box {
  /* width: 800px;
		height: 670px; */
  overflow: hidden;
  background-color: #fff;
  /* position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto; */
}

.newpage .el-icon-loading:before {
  content: "\E6CF";
  font-size: 60px;
}

.newpage .loading_style {
  background-color: #454040;
  position: absolute !important;
  width: 100%;
  height: 100vh;
  left: 0;
}

.el-popper {
  z-index: 999999 !important;
}

.img-wrapper {
  width: 1100px;
  height: 1188px;
  margin: -369.5px -354.5px;
  transform: scale(0.36);
}

.fenpi {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  z-index: 999999;
  font-size: 14px;
  padding-left: 15px;
}

.fenpi-item {
  margin-right: 10px;
}
</style>
